module.exports = __webpack_public_path__ + "b72d9d79fcf38e9eaf7990542ee2ec3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/icons/workout.png
// module id = 1889
// module chunks = 1